import { decrypt } from '@/lib'
import { UserModel } from '@/models/db'
import { NextFunction, Request, Response } from 'express'

interface TokenData {
  _id: string
  username: string
}

//access token verification
export const accessTokenVerification = async (
  req: Request,
  res: Response,
  next: NextFunction,
) => {
  const token = req.header('Authorization')
  if (!token) {
    return res.status(401).json({ message: 'Access denied' })
  }
  try {
    const decoded = (await decrypt(token)) as TokenData
    const userexist = await UserModel.findUnique({
      where: { username: decoded.username, id: decoded._id },
    })
    if (!userexist) {
      return res.status(401).json({ message: 'Invalid token' })
    }
    next()
  } catch (err) {
    return res.status(401).json({ message: 'Invalid token' })
  }
}
